@if (userStream && streamData) {
    <div class="head-row col w100 gap-8" i18n>
        <div class="row space-between align-center w100">
            <h2>{{ userStream.name || 'Your new Idea' }}</h2>
            <div class="col gap-4">
                <div class="uppercase-label createdat">
                    CREATED:
                    {{ userStream.dateCreate | date: 'mediumDate' }}
                </div>
                <rr-btn type="link" (click)="showChatSummaries = true"
                    >Show Chat Summaries</rr-btn
                >
            </div>
        </div>
        <div class="row gap-8 chip-container">
            @for (c of streamData.categoryId; track c; let i = $index) {
                <rr-badge [tone]="i === 0 ? 'brand' : 'warning'">{{
                    c | getCategoryNameById
                }}</rr-badge>
            }

            <rr-badge>{{ streamData.name }}</rr-badge>
        </div>
    </div>
    @if (finalAssets && finalAssets.length > 0) {
        <div class="row resultitems gap-24" i18n>
            @for (item of finalAssets; track item; let i = $index) {
                <div class="card col space-between">
                    <div class="col align-center">
                        <div class="uppercase-label w100 text-center">
                            RESULT
                        </div>
                        <h4 class="text-center">
                            {{ item.name }}
                            <!-- {{ userStream.results![userStream.results!.length - 1].name }} -->
                        </h4>
                    </div>

                    <div class="col gap-16 w100">
                        <div class="col align-center w100">
                            <img src="/images/pdficon.png" alt="" />
                        </div>
                        @if (item && item.created !== undefined) {
                            <rr-btn
                                type="Primary"
                                size="Medium"
                                class="w100"
                                iconStart="external_link"
                                (click)="openRessource(item)"
                                >Show</rr-btn
                            >
                        } @else {
                            <rr-btn
                                type="Secondary"
                                size="Medium"
                                class="w100"
                                [disabled]="true"
                                >Processing...</rr-btn
                            >
                        }
                    </div>
                </div>
            }

            @if (finalAssets.length && showChatSummaries === true) {
                <div class="trenner col"></div>
            }

            @if (showChatSummaries === true) {
                @for (item of steResults; track item; let i = $index) {
                    <div
                        class="card col space-between"
                        (click)="openRessource(item)"
                    >
                        <div class="col">
                            <div class="uppercase-label w100 text-center">
                                STEP {{ i + 1 }}
                            </div>
                            <h4 class="text-center">{{ item.name }}</h4>
                        </div>

                        <div class="col gap-16 w100">
                            <div class="col align-center w100">
                                <img src="/images/pdficon.png" alt="" />
                            </div>
                            <rr-btn
                                type="Secondary"
                                size="Medium"
                                class="w100"
                                iconStart="external_link"
                                >Show</rr-btn
                            >
                        </div>
                    </div>
                }
            }
        </div>
    }
} @else {
    <rr-spinner></rr-spinner>
}
